import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientListScreen } from 'screens/patient';

export default withPermissions(PatientListScreen, [GroupSecurity.PatientRead]);
